// extracted by mini-css-extract-plugin
export default {"reward":"SummaryVisionsStars_reward__+BP4O"};